import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.match.js";
import axios from 'axios';
import { merge } from 'lodash';
import store from '@/store';
import util from '@/libs/util';
import Setting from '@/setting';
import Toast from '@/utils/toast';
import fileDownload from 'js-file-download';

// 创建一个错误
function buildError(code, message) {
  code = code || '500';
  return {
    code: code,
    msg: message || '网络异常，请联系管理员！',
    error: true,
    success: false
  };
}

// 记录和显示错误
function showError(msg) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.error('>>>>>> Error >>>>>>');
  }
  // 显示提示，可配置使用 View UI Plus 的 $Message 还是 $Notice 组件来显示
  if (Setting.request.errorModalType === 'Message') {
    Toast.Message.error(msg);
  } else if (Setting.request.errorModalType === 'Notice') {
    Toast.Notice.error(msg);
  }
}
function recordErrorLog(msg, url) {
  // 添加到日志
  store.dispatch('admin/log/push', {
    message: '数据请求异常',
    type: 'error',
    meta: {
      error: new Error(msg + ":" + url)
    }
  });
  showError(msg, url);
}

// 创建一个 axios 实例
var service = axios.create({
  baseURL: Setting.request.apiBaseURL,
  timeout: Setting.request.timeout
});

// 请求拦截器
service.interceptors.request.use(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(config) {
    var _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _t = merge;
          _t2 = config;
          _context.n = 1;
          return Setting.request.requestConfig(config, util);
        case 1:
          return _context.a(2, _t(_t2, _context.v));
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  // 发送失败
  Promise.reject(error);
});
function download(response, fileName, resolve, reject) {
  if (!fileName) {
    fileName = response.headers['content-disposition'].match(/filename=(\S*)/)[1];
  }
  if (fileName) {
    fileDownload(response.data, decodeURI(fileName));
    resolve();
  } else {
    reject();
  }
}

// 响应拦截器
service.interceptors.response.use(function (response) {
  return new Promise(function (resolve, reject) {
    if (/application\/json/.test(response.headers['content-type'])) {
      // dataAxios 是 axios 返回数据中的 data
      var dataAxios = response.data;
      var responseType = response.request.responseType;
      if (responseType === 'blob') {
        // 文件流
        var reader = new FileReader();
        reader.readAsText(dataAxios, 'utf-8');
        reader.onload = function () {
          var result = JSON.parse(reader.result);
          handleResponse(result, response, resolve, reject);
        };
      } else {
        handleResponse(dataAxios, response, resolve, reject);
      }
    } else {
      download(response, '', resolve, reject);
    }
  });
}, function (error) {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误';
        break;
      case 401:
        error.message = '未授权，请登录';
        break;
      case 403:
        error.message = '拒绝访问';
        break;
      case 404:
        error.message = "\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ".concat(error.response.config.url);
        break;
      case 408:
        error.message = '请求超时';
        break;
      case 500:
        error.message = '服务器内部错误';
        break;
      case 501:
        error.message = '服务未实现';
        break;
      case 502:
        error.message = '网关错误';
        break;
      case 503:
        error.message = '服务不可用';
        break;
      case 504:
        error.message = '网关超时';
        break;
      case 505:
        error.message = 'HTTP版本不受支持';
        break;
      default:
        break;
    }
  } else if (error.message === 'Network Error') {
    error.message = '服务器网络异常，暂不可用';
    if (Setting.request.errorModalType === 'Message') {
      Toast.Message.error(error.message);
    } else if (Setting.request.errorModalType === 'Notice') {
      Toast.Notice.error(error.message);
    }
  }
  recordErrorLog(error.message, error.response && error.response.config && error.response.config.url);
  return Promise.reject(error);
});
function handleResponse(dataAxios, response, resolve, reject) {
  // result 是 axios 返回数据中的 data
  var result = response.request.responseType == 'blob' ? dataAxios : response.data;
  // 这个状态码是和后端约定的
  var code = result.code;
  // 根据 code 进行判断
  if (code === undefined) {
    // 如果没有 code 代表这不是项目后端开发的接口
    resolve(result);
  } else {
    // 有 code 代表这是一个后端接口 可以进行进一步的判断
    switch (code) {
      case '200':
        resolve(result);
        break;
      case '999':
        store.dispatch('admin/account/logout');
        // showError('请重新登录',response.config.url);
        reject(buildError(result.code, result.msg));
        break;
      default:
        recordErrorLog(result.msg, response.config.url);
        reject(buildError(result.code, result.msg));
        break;
    }
  }
}
export default service;